<template>
  <div id="app">
    <header>
      <div class="top-bar" :class="{'shrink': isShrunk}">
        <router-link to="/">
            <img src="@/assets/logo.png" alt="Logo" class="logo"/>
        </router-link>
        <div class="hamburger" @click="toggleMenu">
          &#9776;
        </div>
      </div>
      <nav class="navbar">
        <ul :class="['navbar-items', {'navbar-open': menuOpen}]">
          <li><router-link @click.native="closeMenu" to="/">Start</router-link></li>
          <li><router-link @click.native="closeMenu" to="/aboutme/">Über mich</router-link></li>
          <li class="dropdown">
            <a href="#" class="dropbtn">Beratung</a>
            <ul class="dropdown-content">
              <li><router-link @click.native="closeMenu" to="/stillberatung/">Stillberatung</router-link></li>
              <li><router-link @click.native="closeMenu" to="/schlafberatung/">Schlafberatung</router-link></li>
              <li><router-link @click.native="closeMenu" to="/beikostberatung/">Beikostberatung</router-link></li>
            </ul>
          </li>
          <li class="dropdown">
            <a href="#" class="dropbtn">Kurse</a>
            <ul class="dropdown-content">
              <li><router-link @click.native="closeMenu" to="/stillvorbereitung/">Stillvorbereitung</router-link></li>
              <li><router-link @click.native="closeMenu" to="/schlafworkshop/">Schlafworkshop</router-link></li>
              <li><router-link @click.native="closeMenu" to="/beikostworkshop/">Beikostworkshop</router-link></li>
              <li><router-link @click.native="closeMenu" to="/papa-krabbelgruppe/">Papa-Krabbelgruppe</router-link></li>
            </ul>
          </li>
          <li><router-link @click.native="closeMenu" to="/preise/">Preise</router-link></li>
          <li><router-link @click.native="closeMenu" to="/kontakt/">Kontakt</router-link></li>
          <li class="more">
            <a href="#" class="morebtn">...</a>
            <ul class="more-content">
              <li><router-link @click.native="closeMenu" to="/datenschutz/">Datenschutz</router-link></li>
              <li><router-link @click.native="closeMenu" to="/Impressum/">Impressum</router-link></li>
            </ul>
          </li>
        </ul>
      </nav>
      <div class="separator">
        <!-- Maikes Familienbegleitung. Beratung und Angebote rund um Stillen, Schlaf und Beikost in Koblenz. BFB bindungsorientierte Familienbegleiterin&reg;. -->
        <br/>
      </div>
    </header>
    <main>
      <router-view/>
    </main>
    <Footer/>
  </div>
</template>

<script>
import Footer from './Footer.vue';

export default {
  components: {
    Footer
  },
  data() {
    return {
      menuOpen: false,
      isShrunk: false
    };
  },
  methods: {
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
      if (this.menuOpen)
        this.isShrunk = true;
      else
        this.isShrunk = window.scrollY > 0;
    },
    closeMenu() {
      this.menuOpen = false;
      this.isShrunk = window.scrollY > 0;
    },
    handleScroll() {
      this.isShrunk = this.menuOpen || window.scrollY > 0;
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  }
}
</script>

<style>
@font-face {
  font-family: 'Roboto';
  src: url('@/assets/fonts/Roboto-Regular.woff2') format('woff2');
  font-weight: normal;
  font-style: normal;
}
body {
  font-family: 'Roboto', sans-serif;
  margin: 0;
  padding: 0;
  font-size: 1rem; /* 16px */
}

html, body, #app {
  height: 100%;
  margin: 0;
  background-color: var(--secondary-color);
}

#app {
  display: flex;
  flex-direction: column;
}

.separator {
  font-size: 0.625rem; /* 10px */
  color: var(--secondary-color);
  background-color: var(--secondary-color);
}

main {
  flex: 1;
  color: var(--font-color);
  text-align: left;
  width: 90%;
  max-width: 50rem; /* 800px */
  margin: 12rem auto 0 auto; /* 192px */
  padding: 1.25rem; /* 20px */
}

section {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 3rem;
  padding: 1rem 2rem 2rem 2rem;
  background-color: #a7e1b7;
  border-radius: 30px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

@media (max-width: 600px) {
  section {
    padding: 0rem 1rem 2rem 1rem;
  }
}

.hero-text {
 flex: 1;
 margin-right: 1rem;
}

.hero-image img {
  max-width: 300px;
  margin: 1rem 0;
  border-radius: 9999px;
}

.hero-text h1 {
  font-size: 2rem;
  margin-bottom: 1rem;
}

.cta-button {
  background-color: #83de9b;
  border: none;
  padding: 0.75rem 1.5rem;
  margin-right: 1rem;
  margin-bottom: 1rem;
  font-weight: bold;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.3s ease;
  text-decoration: none;
  color: var(--font-color);
}

.cta-button:hover {
  background-color: #6fcf90;
}

header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  color: var(--secondary-font-color);
  background-color: var(--primary-color);
}

.top-bar {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  background-color: var(--primary-color);
  width: 100%;
  transition: all 0.3s ease;
}

.top-bar.shrink {
  width: 100%;
  height: 0%;
}

.logo {
  height: 9.375rem; /* 150px */
  transition: all 0.5s ease;

}
  
.top-bar.shrink .logo {
  position: absolute;
  transform: translateX(0);
  left: 0;
  top: 0;
  transform: translateY(-35%) scale(0.25);
}


.hamburger {
  display: none;
  color: var(--secondary-font-color);
  font-size: 1.875rem; /* 30px */
  cursor: pointer;
  position: absolute;
  right: 0.625rem; /* 10px */
  top: 0.3125rem; /* 5px */
}

.navbar {
  background-color: var(--primary-color);
  width: 100%;
  transition: all 0.3s ease;
}

.navbar-items {
  display: flex;
  list-style-type: none;
  padding: 0;
  margin: 0;
  justify-content: center;
}

.navbar-items li {
  position: relative;
}

.navbar-items a {
  color: var(--secondary-font-color);
  padding: 0.875rem 1rem; /* 14px 16px */
  text-decoration: none;
  display: block;
}

.navbar-items li:hover > a {
  background-color: var(--tertiary-color);
}

.dropdown-content,
.more-content {
  display: none;
  position: absolute;
  background-color: var(--tertiary-color);
  min-width: 10rem; /* 160px */
  box-shadow: 0 0.5rem 1rem 0 rgba(0,0,0,0.2);
  z-index: 1;
  padding: 0;
  list-style-type: none;
}

.dropdown-content a,
.more-content a {
  color: var(--secondary-font-color);
  padding: 0.75rem 1rem; /* 12px 16px */
  text-decoration: none;
  display: block;
  margin: 0;
}

.dropdown-content a:hover,
.more-content a:hover {
  background-color: var(--primary-color);
}

.dropdown:hover .dropdown-content,
.more:hover .more-content {
  display: block;
}




@media (max-width: 45rem) {
  main {
    margin-top: 10rem; /* 150px */
  }
  .navbar-items {
    display: none;
    flex-direction: column;
    align-items: center;
    width: 100%;
    background-color: var(--primary-color);
    position: absolute;
    top: 3.125rem; /* 50px */
    left: 0;
    z-index: 1000;
  }
  
  .navbar-items.navbar-open {
    display: flex;
  }
  
  .hamburger {
    display: block;
  }
  
  .top-bar.shrink .hamburger {
    top: 0.3125rem; /* 5px */
  }
  
  .logo {
    position: absolute;
    left: 50%;
    top: 0.3125rem; /* 5px */
    transform: translateX(-50%) scale(1);
    transition: all 0.3s ease;
  }
  
  .top-bar.shrink .logo {
    transform: translateX(-50%) translateY(-37%) scale(0.25);
    left: 50%;
    top: 0.3125rem; /* 5px */
  }
  
  .top-bar {
    height: 10rem; /* 160px */
  }
  
  .top-bar.shrink {
    height: 3.125rem; /* 50px */
  }
  

}
</style>